module.exports = __webpack_public_path__ + "static/tetromino-9adf40bdcb5c5d1584ddee9c9f7ce9a3.gif";